// A Reserve plan's automatic payments end at its Deadline (four weeks before
// departure), when Stripe cancels the plan's subscription. The trip stays
// 'active' in reserve_trips after that, so this is the signal that its plan
// has ended: switching flights reworks the payment schedule on that
// subscription and Stripe refuses it. No imports, so the server can use it.
export function reservePlanEnded(trip, now = new Date()) {
  if (!trip || trip.status !== 'active' || !trip.deadline_date) return false;
  const deadline = new Date(trip.deadline_date);
  return !Number.isNaN(deadline.getTime()) && now.getTime() >= deadline.getTime();
}

export const RESERVE_PLAN_ENDED_SWITCH_ERROR =
  'This Reserve plan has ended, so its flights can’t be switched. You can still use your Reserve balance on any flight: choose Reserve as your payment method at checkout.';
